import { render } from "./ViewLegalEntities.vue?vue&type=template&id=22ed1080"
import script from "./ViewLegalEntities.vue?vue&type=script&lang=js"
export * from "./ViewLegalEntities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__